import { styled, Box, Theme } from '@streem/ui-react';

export const DeviceSettingsWrapper = styled(Box)`
    cursor: pointer;
    :hover {
        background: ${Theme.colors.blue05};
    }
`;
